module.exports = __webpack_public_path__ + "static/media/footer_cat.f9a7541a.svg";